module.exports = __webpack_public_path__ + "static/hero-10-7847e0ddb934581f1472627f1b2fcff9.jpg";